module.exports = __webpack_public_path__ + "static/logo-white-c16a4dd65f9dcb94218a7bfd270bbe7a.png";